import { createAsyncThunk } from '@reduxjs/toolkit';
import { userEventLogService, UserEventLogListParams, UserEventLogListResponse } from '../../services/api/userEventLogService';

export const fetchMyEvents = createAsyncThunk<
  UserEventLogListResponse,
  UserEventLogListParams | undefined,
  { rejectValue: string }
>(
  'userEventLog/fetchMyEvents',
  async (params = {}, { rejectWithValue }) => {
    try {
      return await userEventLogService.getMyEvents(params);
    } catch (error) {
      return rejectWithValue(userEventLogService.getErrorMessage(error));
    }
  }
);

export const fetchAllEvents = createAsyncThunk<
  UserEventLogListResponse,
  UserEventLogListParams | undefined,
  { rejectValue: string }
>(
  'userEventLog/fetchAllEvents',
  async (params = {}, { rejectWithValue }) => {
    try {
      return await userEventLogService.getAllEvents(params);
    } catch (error) {
      return rejectWithValue(userEventLogService.getErrorMessage(error));
    }
  }
);
